/**
 * Locked by ADR-0043: the shared kundali form always captures a valid phone as
 * the recurring customer identity. Marketing consent is deliberately separate
 * from this required transactional identity/save action.
 */
export const KUNDALI_PHONE_CAPTURE_POLICY = Object.freeze({
  required: true,
  consentMarketing: false,
});
